const storageUser = `${process.env.NODE_ENV}-OTA-User`
const storageOrder = `${process.env.NODE_ENV}-OTA-Order`
const storageOrderBundle = `${process.env.NODE_ENV}-OTA-OrderBundle`

export const storageKeys = {
  user: storageUser,
  order: storageOrder,
  orderBundle: storageOrderBundle
}
